// useSocket.js
import { io } from "socket.io-client";
import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext.js";

export function useSocket() {
  const { isAuthenticated, user } = useAuth();
  const [socket, setSocket] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) {
      // If not logged in, do NOT connect
      if (socket) {
        socket.disconnect();
      }
      setSocket(null);
      return;
    }

    // If logged in, connect
    const newSocket = io("http://localhost:8000", { /* options */ });
    setSocket(newSocket);

    // Join the room
    if (user?.id) {
      newSocket.emit("join", user.id);
    }

    return () => {
      newSocket.disconnect();
    };
  }, [isAuthenticated, user?.id]);

  return socket;
}
